import React, { useEffect, useContext, useState} from "react";
import { headerFreightTable, mock } from "./utils";
import { format } from 'date-fns';
import {
    Table,
    HeaderRow,
    ItemRow,
    HeaderCell,
    ItemCell,
    ItemCellContainer,
    ImageCell,
    OptionsImage,
    StatusText,
}from "./style"


import details from '../../../../assets/router/details.svg';
import edit from '../../../../assets/router/edit-pen.svg';
import trash from '../../../../assets/router/trash.svg';
import ModalContext from "../../../../contexts/ModalContext";
import { FreightContext } from "../../../../contexts/FreightContext";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import { RouterOutletType } from "../index2";
import SectionContext from "../../../../contexts/SectionContext";
import { GlobalTable, HeaderLine, LoadMoreButton, Td, TdButtons, Th, Tr } from "../../../../components/styles/table-style";
import { FeedbackContext } from "../../../../contexts/FeedbackContext";

interface FreightTableType {
    onChange?: () => void
  }
  interface Freight {
    id: number;
    type: string;
    status: string;
    deadLine: string;
    company: any;
    readyToShip: string;
    load: any
    // Add other properties as needed
  }
 


const FreightTable: React.FC<FreightTableType> = (props)=>{
    const {freight, setFreight} = useContext(FreightContext)
    const { setModalActive, setModalSection } = useContext(ModalContext);
    const {setRouterSection} = useContext(SectionContext)
    const [freights, setFreights] = useState<Freight[]>([]);
    const { setFeedback } = useContext(FeedbackContext)
    const navigate = useNavigate()
    const tratadorDeErro = {
      type: "",
      detail: "",
      deadLine: "",
      address: {
        street: "",
        number: "",
        complement: "",
        cep: 0,
        neighborhood: {
          name: "",
          city: {
            name: "",
            state: {
              name: "",
              uf: ""
            }
          }
        }
      },
      load: {
        height: "",
        width: "",
        length: "",
        cubage: "",
        weight: ""
      }
    }

    const dataFormatter = (isoDateString: string): string => {
      if (!isoDateString) {
          return ''; // Retorna vazio se a string for nula ou vazia
      }
  
      const dateUtc = new Date(isoDateString);
  
      // Verifica se a data é válida antes de tentar formatar
      if (isNaN(dateUtc.getTime())) {
          console.error("Data ISO inválida recebida:", isoDateString);
          return ''; // Trata o caso de uma string de data inválida
      }
  
      // Extrai as partes da data diretamente do UTC
      const year = dateUtc.getUTCFullYear();
      const month = dateUtc.getUTCMonth() + 1; // getUTCMonth é 0-indexado, então adiciona 1
      const day = dateUtc.getUTCDate();
  
      // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;
  
      return `${formattedDay}/${formattedMonth}/${year}`;
  };

    const handleEditFreight = async (id: number)=>{
        //  setModalActive(true)
        //  setModalSection('routerFreightForm')

         setFreight(await getFreight(id))
         navigate('create')
    }

    const  handleViewFreight = async (id: number)=>{
        // setModalActive(true)
        // setModalSection("routerFreightDetail")
        setFreight(await getFreight(id))
        navigate(`${id}`)
    }
    const getFreight = async (id: number)=>{
      const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/freight/${id}`);
      return response.data
    }

    const  getFreights = async () =>{
        const response = await axios.get(`${process.env.REACT_ROUTER_BASE_URL}/freight`);
        return response.data
    }

    const deleteFreight = async (id: number)=>{
       try{
        await axios.delete(`${process.env.REACT_APP_ROUTER_BASE_URL}/freight/${id}`);
        const freights = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/freight/`)
        setFreights(freights.data)
        setFeedback({
          isOpen: true,
          message: 'Frete deletado!',
          statusOk: true
        })
       }catch{
        setFeedback({
          isOpen: true,
          message: 'Erro ao deletar frete',
          statusOk: false
        })
       }
    }
    useEffect(() => {
        const getFreights = async () => {
            // console.log(process.env.REACT_APP_ROUTER_BASE_URL+'/freight')
          const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/freight`);
          console.log(response.data)
          setFreights(response.data);
        };
        getFreights();
      }, []);
      const { setTabIndex } = useOutletContext<RouterOutletType>()
  
      useEffect(() => {
        setTabIndex(0)
        setRouterSection('freight')
      }, [])

      const mapStatus = (status: string): string => {
        if (status === 'A programar') return '';
        if (status === 'Rota programada') return 'pending';
        if (status === 'Endereço pendente' || status === 'Cancelado') return 'cancel';
        if (status === 'Entregue' || status === 'Coletado') return 'completed';
        return status; // Retorna o status original caso não se encaixe nas condições
    };

    return(
        <>
            
            <GlobalTable>
            <thead>
    <HeaderLine >
       {headerFreightTable.map((header)=>(
        <Th key={header}>{header}</Th>
        
       ))} 
        <Th></Th>
    </HeaderLine>
    </thead>
      <tbody >
       {freights.map((item, rowIndex) => (
        <Tr key={item.id}>
          <Td title={item.company?.companyName}>{item.company?.companyName.split(/\s|-/).slice(0, 2).join(' ') + '...'}</Td>
          <Td>{item.type}</Td>
          <Td><StatusText className={mapStatus(item.status)}>{item.status}</StatusText></Td>
          <Td>
  {item.readyToShip ? (
    new Date(item.readyToShip).setUTCHours(0,0,0,0) <= new Date().setUTCHours(0,0,0,0) ? 
    'Liberado' : 
    dataFormatter(item.readyToShip)
  ) : ''}
</Td>

          <Td>{item.deadLine ? dataFormatter(item.deadLine) : ''}</Td>

          
          <TdButtons>
          <OptionsImage  onClick={async () => await handleViewFreight(item.id)} src={details} alt='Icon to show freight' />
          <OptionsImage onClick={async () => await handleEditFreight(item.id)} src={edit} alt='Icon to edit freight' />
          <OptionsImage onClick={async () => await deleteFreight(item.id)} src={trash} alt='Icon to delete freight' />
          </TdButtons>
          
          {/* <ImageCell>
            <OptionsImage onClick={async () => await handleViewFreight(item.id)} src={details} alt='Icon to show freight' />
          </ImageCell>
          <ImageCell>
            <OptionsImage onClick={async () => await handleEditFreight(item.id)} src={edit} alt='Icon to edit freight' />
          </ImageCell>
          <ImageCell>
            <OptionsImage onClick={async () => await deleteFreight(item.id)} src={trash} alt='Icon to delete freight' />
          </ImageCell> */}
        </Tr>
      ))}
      </tbody>
    </GlobalTable>
    <LoadMoreButton style={{marginBottom: '1rem'}}>Carregar mais</LoadMoreButton>
        </>

    )
}

export default FreightTable